// _app/immutable/assets/Image.1c236230.css
export default ".image.svelte-1rlhb4t{height:100%;width:100%;border-radius:4rem;box-shadow:0 1.5rem 3rem #0000001a}\n";